export const DATA_UPDATE_ROW = 'DATA_UPDATE_ROW';
export const DATA_ROW_REMOVE = 'DATA_ROW_REMOVE';
export const DATA_MARK_ERRORS_AS_DIRTY = 'DATA_MARK_ERRORS_AS_DIRTY';
export const DATA_UNDO = 'DATA_UNDO';
export const DATA_REDO = 'DATA_REDO';
export const DATA_UNDO_ALL = 'DATA_UNDO_ALL';
